// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ErrorResponse } from '../models';
import { LectureVideo } from '../models';
import { LectureVideoCreate } from '../models';
import { LectureVideoEdit } from '../models';
import { Sort } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * LectureVideoApi - axios parameter creator
 * @export
 */
export const LectureVideoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture video.
         * @param {string} id 
         * @param {string} video_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, video_id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            // verify required parameter 'video_id' is not null or undefined
            if (video_id === null || video_id === undefined) {
                throw new RequiredError('video_id','Required parameter video_id was null or undefined when calling _delete.');
            }
            const localVarPath = `/v1/lecture/{id}/video/{video_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"video_id"}}`, encodeURIComponent(String(video_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture video.
         * @param {string} id 
         * @param {LectureVideoCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LectureVideoCreate, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling create.');
            }
            const localVarPath = `/v1/lecture/{id}/video/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture video.
         * @param {string} id 
         * @param {string} video_id 
         * @param {LectureVideoEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, video_id: string, body?: LectureVideoEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            // verify required parameter 'video_id' is not null or undefined
            if (video_id === null || video_id === undefined) {
                throw new RequiredError('video_id','Required parameter video_id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/lecture/{id}/video/{video_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"video_id"}}`, encodeURIComponent(String(video_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture video.
         * @param {string} id 
         * @param {string} video_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, video_id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            // verify required parameter 'video_id' is not null or undefined
            if (video_id === null || video_id === undefined) {
                throw new RequiredError('video_id','Required parameter video_id was null or undefined when calling get.');
            }
            const localVarPath = `/v1/lecture/{id}/video/{video_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"video_id"}}`, encodeURIComponent(String(video_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture videos.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sort.');
            }
            const localVarPath = `/v1/lecture/{id}/video/sort`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LectureVideoApi - functional programming interface
 * @export
 */
export const LectureVideoApiFp = function(configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture video.
         * @param {string} id 
         * @param {string} video_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, video_id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LectureVideoApiAxiosParamCreator(configuration)._delete(id, video_id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture video.
         * @param {string} id 
         * @param {LectureVideoCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LectureVideoCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LectureVideo> {
            const localVarAxiosArgs = LectureVideoApiAxiosParamCreator(configuration).create(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture video.
         * @param {string} id 
         * @param {string} video_id 
         * @param {LectureVideoEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, video_id: string, body?: LectureVideoEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LectureVideo> {
            const localVarAxiosArgs = LectureVideoApiAxiosParamCreator(configuration).edit(id, video_id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture video.
         * @param {string} id 
         * @param {string} video_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, video_id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LectureVideo> {
            const localVarAxiosArgs = LectureVideoApiAxiosParamCreator(configuration).get(id, video_id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture videos.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LectureVideoApiAxiosParamCreator(configuration).sort(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LectureVideoApi - factory interface
 * @export
 */
export const LectureVideoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture video.
         * @param {string} id 
         * @param {string} video_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, video_id: string, options?: any) {
            return LectureVideoApiFp(configuration)._delete(id, video_id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture video.
         * @param {string} id 
         * @param {LectureVideoCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LectureVideoCreate, options?: any) {
            return LectureVideoApiFp(configuration).create(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture video.
         * @param {string} id 
         * @param {string} video_id 
         * @param {LectureVideoEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, video_id: string, body?: LectureVideoEdit, options?: any) {
            return LectureVideoApiFp(configuration).edit(id, video_id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture video.
         * @param {string} id 
         * @param {string} video_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, video_id: string, options?: any) {
            return LectureVideoApiFp(configuration).get(id, video_id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture videos.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options?: any) {
            return LectureVideoApiFp(configuration).sort(id, body, options)(axios, basePath);
        },
    };
};

/**
 * LectureVideoApi - object-oriented interface
 * @export
 * @class LectureVideoApi
 * @extends {BaseAPI}
 */
export class LectureVideoApi extends BaseAPI {
    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Delete lecture video.
     * @param {string} id 
     * @param {string} video_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureVideoApi
     */
    public _delete(id: string, video_id: string, options?: any) {
        return LectureVideoApiFp(this.configuration)._delete(id, video_id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Create new lecture video.
     * @param {string} id 
     * @param {LectureVideoCreate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureVideoApi
     */
    public create(id: string, body?: LectureVideoCreate, options?: any) {
        return LectureVideoApiFp(this.configuration).create(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Edit lecture video.
     * @param {string} id 
     * @param {string} video_id 
     * @param {LectureVideoEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureVideoApi
     */
    public edit(id: string, video_id: string, body?: LectureVideoEdit, options?: any) {
        return LectureVideoApiFp(this.configuration).edit(id, video_id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
     * @summary Get lecture video.
     * @param {string} id 
     * @param {string} video_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureVideoApi
     */
    public get(id: string, video_id: string, options?: any) {
        return LectureVideoApiFp(this.configuration).get(id, video_id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Sort lecture videos.
     * @param {string} id 
     * @param {Array<Sort>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureVideoApi
     */
    public sort(id: string, body?: Array<Sort>, options?: any) {
        return LectureVideoApiFp(this.configuration).sort(id, body, options)(this.axios, this.basePath);
    }

}
